import React from "react";
import { Switch } from "components/ui";

function VisiblitySwitch({ checked, onChange, ...rest }) {
  return (
    <Switch
      size="sm"
      checked={checked}
      onCheckedChange={onChange}
      {...rest}
    />
  );
}

export default VisiblitySwitch;
